import { fetchDefuntoCordogli } from '~src/sidebar/annunciFunebri/fetchDefuntoCordogli';
import { fetchAnnuncioFunebre } from '~src/sidebar/annunciFunebri/fetchAnnuncioFunebre';
import $ from 'jquery';
import { editorAddCordoglio } from './editorAddCordoglio';
import { addPage, generateCurrentPageThumbnail } from '~src/multipages';
import { onErrorShowMessage } from '~src/errors';
import Swal from 'sweetalert2';
import { goToPage } from '../../multipages/goToPage';
import { handleSidebarBackgrounds } from '~src/sidebar/index';
import { getStatePure, modifyState } from '~src/state';

const startLoader = () => {
  Swal.fire({
    title: 'Caricamento',
    text: 'Sto scaricando i cordogli…',
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
};

const stopLoader = (totalCordogli) => {
  Swal.fire({
    title: 'Fatto!',
    text: `Il progetto cordogli è pronto, ci sono ${totalCordogli} cordogli`,
    icon: 'success',
    confirmButtonColor: '#278e8e',
    showCloseButton: true,
    didOpen: () => {
      Swal.hideLoading();
    },
  });
};

const insertCordogli = async (hasCordogli, isPageVerticale) => {
  let isParagraphOnTheLeft = true;

  if (isPageVerticale) {
    for (let i = 0; i < hasCordogli.length; i++) {
      await goToPage(i);
      editorAddCordoglio(hasCordogli[i], isParagraphOnTheLeft, isPageVerticale);
      await generateCurrentPageThumbnail();
    }
  } else {
    for (let i = 0; i < hasCordogli.length; i++) {
      if (i > 0 && i % 2 === 0) {
        await goToPage(i / 2);
      }
      editorAddCordoglio(hasCordogli[i], isParagraphOnTheLeft, isPageVerticale);
      await generateCurrentPageThumbnail();
      isParagraphOnTheLeft = !isParagraphOnTheLeft;
    }
  }
};

const templateAndPages = async (hasCordogli, isPageVerticale) => {
  const totalPagesToCreate = isPageVerticale
    ? hasCordogli.length
    : hasCordogli.length / 2;

  for (let i = 0; i < totalPagesToCreate; i++) {
    if (i > 0) {
      await addPage(true);
    }
  }
};

export const onTemplateCordogliChange = async () => {
  const currentPages = getStatePure('pages');

  startLoader();

  if (!window.editorConfig.annunciFunebri) {
    window.editorConfig.annunciFunebri = await fetchAnnuncioFunebre();

    if (!window.editorConfig.annunciFunebri) {
      onErrorShowMessage(false, {
        icon: 'warning',
        title: 'Oops',
        text: 'Non ci sono annunci funebri per questo servizio.',
      });
      return;
    }
  }

  if (currentPages.length > 1) {
    await goToPage(0);
    await modifyState('pages', []);
    await addPage(false);
  }

  let hasCordogli = await fetchDefuntoCordogli();

  if (!hasCordogli || hasCordogli.length === 0 || hasCordogli === 0) {
    Swal.hideLoading();
    onErrorShowMessage(false, {
      icon: 'warning',
      title: 'Oops',
      text: 'Non ci sono messaggi di cordoglio per questo servizio.',
    });
    return false;
  }

  const isPageVerticale = window.canvas.height > window.canvas.width;

  await templateAndPages(hasCordogli, isPageVerticale);
  await goToPage(0);
  await insertCordogli(hasCordogli, isPageVerticale);

  modifyState('sidebarCurrentBackgroundsTag', window.editorConfig.cordogliTag);
  await handleSidebarBackgrounds();
  const tagId = window.editorConfig.sidebarTags.items.find(
    (tag) => tag.name === window.editorConfig.cordogliTag
  );
  $('#select-ricerca-backgrounds').val(tagId.objectId).trigger('change');

  stopLoader(hasCordogli.length);
};
